import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { debugLog } from 'shared/logger/debugLog';
import { companyContract } from 'shared/domain/company/companyContract';
import { makeErrorPublisher } from 'serviceWorker/broadcasts/publishers';

const broadcastCompanyError = makeErrorPublisher(companyContract);

/** `uniqueId` of the failed change lets its command reject with this error. */
export const broadcastUploadedCompanyError = (
  error: unknown,
  messageId?: string | null,
  uniqueId?: string
): void => {
  debugLog('broadcastUploadedCompanyError', error, messageId, uniqueId);
  broadcastCompanyError(DomainMessagesTypes.failUploadedEntity, error, {
    messageId: messageId || undefined,
    uniqueId,
  });
};
